import React from 'react';

const TextIcons = (props) => {

    const renderContent = () => {
        if (props.data) {
            return props.data.map((item, key) => {
                return (
                    <div key={key} className="flex-item">
                        <div className="text-icon">
                            <img src={item.image} alt={item.title} />
                            <h3>{ item.title }</h3>
                            { (item.description ? <p>{ item.description }</p> : '') }
                        </div>
                    </div>
                );
            });
        }
    };

    return (
        <div className="flex-container">
            {renderContent()}
        </div>
    )

};

export default TextIcons;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/TextIcons.js